import { render, staticRenderFns } from "./StudentExamDetail.vue?vue&type=template&id=2d20ccc9&scoped=true"
import script from "./StudentExamDetail.vue?vue&type=script&lang=js"
export * from "./StudentExamDetail.vue?vue&type=script&lang=js"
import style0 from "./StudentExamDetail.vue?vue&type=style&index=0&id=2d20ccc9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d20ccc9",
  null
  
)

export default component.exports